// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3CX6z","info":"PatientInfo_info__1Oot6"};